var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{style:(_vm.styles.path),attrs:{"d":_vm.pathD}}),_vm._l((_vm.pointsPositions),function(p,index){return _c('circle',{key:'l' + index,style:(_vm.styles.circles),attrs:{"cx":p[0],"cy":p[1],"r":"2.5"}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }